import log from 'loglevel'
import rooms from '../res/roomnames.json'
import { t } from 'i18next'

export function KDtimeToDays(timeString) {
    let helpstring = timeString
    helpstring = helpstring.split(".", 3)
    let hs2 = helpstring[2].split(":",2)
    helpstring = [helpstring[0] , helpstring[1], hs2[0], hs2[1]]

    let myOne

    if((parseInt(helpstring[2], 10) + parseInt(helpstring[3], 10)) > 0){
        myOne = 1
    } else { 
        myOne = 0
    }
    myOne=0

    return (parseInt(helpstring[0],10) * 365 + parseInt(helpstring[1], 10) + myOne)
}

export function kdtimeToYDHMobject(kdtime){
    let myTimeObject = {
        years: 0,
        days: 0,
        hours: 0,
        minutes : 0
    }

    if(!kdtime){
        return myTimeObject
    }

    let firstSeparatorPos = kdtime.indexOf('.',0)
    log.debug(firstSeparatorPos)
    let yearString = kdtime.slice(0, firstSeparatorPos)
    log.debug(yearString)
    let leftOver1 = kdtime.slice(firstSeparatorPos + 1, kdtime.length)
    log.debug(leftOver1)
    let secondSeparatorPos = leftOver1.indexOf('.', 0)
    let dayString = leftOver1.slice(0,secondSeparatorPos)
    log.debug(dayString)
    let leftOver2 = leftOver1.slice(secondSeparatorPos + 1, leftOver1.length)
    log.debug(leftOver2)
    let thirdSeparatorPos = leftOver2.indexOf(':', 0)

    let hourString = leftOver2.slice(0, thirdSeparatorPos)
    let minuteString = leftOver2.slice(thirdSeparatorPos + 1 , leftOver2.legth)

    log.debug(hourString)
    log.debug(minuteString)

    myTimeObject.years = parseInt(yearString,10)
    myTimeObject.days = parseInt(dayString,10)
    myTimeObject.hours = parseInt(hourString,10)
    myTimeObject.minutes = parseInt(minuteString,10)

    log.debug(myTimeObject)


    return myTimeObject

}

export function parseShortIsoDateTimeStringToKDdate(shortIsoDTstring){

    let retVal = shortIsoDTstring[8] + shortIsoDTstring[9] + "." + shortIsoDTstring[5] + shortIsoDTstring[6] + "." + shortIsoDTstring[2] + shortIsoDTstring[3]
    log.debug(retVal)
    return retVal

}

export function parseShortIsoDateTimeStringToKDtime(shortIsoDTstring){

    let retVal = shortIsoDTstring.slice(11, 16) + ":00"
    log.debug(retVal)
    return retVal

}

export function getBitValueFromByteArray(desiredBit,  inputType, inputVal){
    
    
    log.debug(desiredBit,  inputType, inputVal)

    if( desiredBit < 0){
        return false
    }
    if(inputType !== "int" && inputType !== "string"){
        return false
    }
    if(inputType === "string"){
        inputVal = parseInt(inputVal, 16)
    }

    log.debug(inputVal)

    if(((inputVal / (Math.pow(2, desiredBit))) & 1) === 1){
        log.debug(inputVal)
        return true
    } else {
        return false
    }

}

export function isThereAnErrorMsg(inputstring){
    if(!inputstring){
        return false
    }
    if((parseInt(inputstring[0],16) + parseInt(inputstring[1],16)) === 0){
        return false
    } else {
        return true
    }
}

export function parseErrorMsgToNiceText(inputstring) {
    let textMessage = "Daten ausstehend..."
    log.debug(inputstring)
    if(!inputstring){
        return textMessage
    }
    log.debug(inputstring)
    switch ((parseInt(inputstring[0], 16) * 16 + parseInt(inputstring[1], 16))) {
        case 1:
            textMessage = t('DeviceInformation.error_message_001')
            break;
        case 2:
            textMessage = t('DeviceInformation.error_message_002')
            break;
        case 128:
            textMessage = t('DeviceInformation.error_message_128')
            break;
        case 129:
            if(parseInt(inputstring[7], 10) === 4){
                textMessage = t('DeviceInformation.error_message_129') + inputstring.substr(2,8) +")"
            } else {
                textMessage = t('DeviceInformation.error_message_129') + inputstring.substr(2,7) +")"
            }
            
            break;
        case 130:
            textMessage = t('DeviceInformation.error_message_130')
            break;
        case 131:
            textMessage = t('DeviceInformation.error_message_131')
            break;

        case 0:
        default:
            textMessage = t('DeviceInformation.error_message_000')
            break;
    }
    return textMessage
}

export function parseShockVentNumberToString(shockVentNumber) {
    log.debug(shockVentNumber)
    switch (parseInt(shockVentNumber, 10)) {
        case 0:
            return 'Beides'
        case 1:
            return 'Abluft'
        case 2:
            return 'Zuluft'
        default:
            log.debug(shockVentNumber)
            return 'Fehler'
    }
}

export function parseAreaSlidersToBitMask(areas){
    let bitMask = 0
    for (let index = 1; index <( 7); index++) {
        // log.debug(areas[index])
        if(areas[`${index}`] === true){
            bitMask += Math.pow(2,(index-1))
        }
        
    }
    // log.debug(bitMask)
    return bitMask
}

export function parseDIfunctionNameToNumber(funName) {
    switch (funName) {
        default:
        case "Keine":
            return 0;
        case "Setze Lüfterstufe 0":
            return 1;
        case "Setze Lüfterstufe 1":
            return 2;
        case "Setze Lüfterstufe 2":
            return 3;
        case "Setze Lüfterstufe 3":
            return 4;
        case "Setze Lüfterstufe 4":
            return 5;
        case "Setze Lüfterstufe 5":
            return 6;
        case "Setze Lüfterstufe 6":
            return 7;
        case "Setze Stoßlüftung":
            return 8;
        case "Setze Schlummer":
            return 9;
        case "Setze Zeitautomatik":
            return 10;
        case "Setze CO2":
            return 11;
        case "Setze Feuchte":
            return 12;
        case "Setze Filter zurück":
            return 13;
        case "Halte Lüfterstufe 0":
            return 14;
        case "Halte Lüfterstufe 1":
            return 15;
        case "Halte Lüfterstufe 2":
            return 16;
        case "Halte Lüfterstufe 3":
            return 17;
        case "Halte Lüfterstufe 4":
            return 18;
        case "Halte Lüfterstufe 5":
            return 19;
        case "Halte Lüfterstufe 6":
            return 20;
        case "Halte Stoßlüftung":
            return 21;
        case "Halte Zeitautomatik":
            return 22;
        case "Halte CO2":
            return 23;
        case "Halte Feuchte":
            return 24;

    }
}

export function parseAIfunctionNameToNumber(funName) {
    switch (funName) {
        default:
        case "Keine":
            return 0;
        case "Lüfterstufe":
            return 1;
        case "Feuchte":
            return 2;
        case "CO2":
            return 3;
        case "Innentemperatur":
            return 4;
        case "Aussentemperatur":
            return 5;
    }
}

export function parseAIfunNumberToName(funNumber) {
    switch (funNumber) {
        default:
        case 0:
            return "Keine"
        case 1:
            return "Lüfterstufe";
        case 2:
            return "Feuchte";
        case 3:
            return "CO2";
        case 4:
            return "Innentemperatur";
        case 5:
            return "Aussentemperatur";      
    }
}

export function parseVentSysNameToNumber(ventSysName) {
    switch (ventSysName) {
        default:
        case "Keins":
            return 0;
        case "SEVi160":
            return 1;
        case "SEVi200":
            return 2;
        case "SEVi160D Mini Abluft":
            return 3;
        case "SEVi160D Mini":
            return 4;
        case "SEVi160 S":
            return 5;
        case "SEVi160 Eco":
            return 6;
        case "SEVi160 PRO-S":
            return 7;
        case "SEVi160 PRO-ECO":
            return 8;
        case "SEVi160D Mini PRO Abluft":
            return 9;
        case "SEVi160D Mini PRO":
            return 10;
        case "Konfigurierbares Gerät":
            return 11;
    }
}

export function parseAItypeNameToNumber(aiTypeName){
    if(aiTypeName === "4-20mA"){
        return 1
    }
    return 0
}

export function parseAItypeNumberToName(aiTypeNumber){
    if(aiTypeNumber === 1){
        return "4-20mA"
    }
    return "0-10V"
}

export function parseVentSysAreaNameToNumber(areaName) {
    switch (areaName) {
        default:
        case "Bereich 1":
            return 1;
        case "Bereich 2":
            return 2;
        case "Bereich 3":
            return 3;
        case "Bereich 4":
            return 4;
        case "Bereich 5":
            return 5;
        case "Bereich 6":
            return 6;
    }
}

export function parseVentSysAreaNumberToName(areaNumber) {
    switch (parseInt(areaNumber, 10)) {
        default:
        case 1:
            return "Bereich 1";
        case 2:
            return "Bereich 2";
        case 3:
            return "Bereich 3";
        case 4:
            return "Bereich 4";
        case 5:
            return "Bereich 5";
        case 6:
            return "Bereich 6";

    }
}


export function parseVentSysNumberToName(ventSysNumber) {
    switch (parseInt(ventSysNumber, 10)) {
        default:
        case 0:
            return "Keins";
        case 1:
            return "SEVi160";
        case 2:
            return "SEVi200";
        case 3:
            return "SEVi160D Mini Abluft";
        case 4:
            return "SEVi160D Mini";
        case 5:
            return "SEVi160 S";
        case 6:
            return "SEVi160 Eco";
        case 7:
            return "SEVi160 PRO-S";
        case 8:
            return "SEVi160 PRO-ECO";
        case 9:
            return "SEVi160D Mini PRO Abluft";
        case 10:
            return "SEVi160D Mini PRO";
        case 11:
            return "Konfigurierbares Gerät";
    }
}

export function parseDOfunctionNameToNumber(funName) {
    switch (funName) {
        default:
        case "Keine":
            return 0;
        case "Lüfterstufe 0 aktiv":
            return 1;
        case "Lüfterstufe 1 aktiv":
            return 2;
        case "Lüfterstufe 2 aktiv":
            return 3;
        case "Lüfterstufe 3 aktiv":
            return 4;
        case "Lüfterstufe 4 aktiv":
            return 5;
        case "Lüfterstufe 5 aktiv":
            return 6;
        case "Lüfterstufe 6 aktiv":
            return 7;
        case "Stoßlüftung aktiv":
            return 8;
        case "Schlummer aktiv":
            return 9;
        case "Alle Bereiche Lüfterstufe 0":
            return 10;
        case "Zeitautomatik aktiv":
            return 11;
        case "CO2 aktiv":
            return 12;
        case "Feuchte aktiv":
            return 13;
        case "Filter abgelaufen":
            return 14;
        case "Allgemeine Meldung":
            return 15;
        case "Allgemeiner Fehler":
            return 16;
    }
}

export function parseDIfunNumberToName(funNumber) {
    switch (funNumber) {
        default:
        case 0:
            return "Keine"
        case 1:
            return "Setze Lüfterstufe 0";
        case 2:
            return "Setze Lüfterstufe 1";
        case 3:
            return "Setze Lüfterstufe 2";
        case 4:
            return "Setze Lüfterstufe 3";
        case 5:
            return "Setze Lüfterstufe 4";
        case 6:
            return "Setze Lüfterstufe 5";
        case 7:
            return "Setze Lüfterstufe 6";
        case 8:
            return "Setze Stoßlüftung";
        case 9:
            return "Setze Schlummer";
        case 10:
            return "Setze Zeitautomatik";
        case 11:
            return "Setze CO2";
        case 12:
            return "Setze Feuchte";
        case 13:
            return "Setze Filter zurück";
        case 14:
            return "Halte Lüfterstufe 0";
        case 15:
            return "Halte Lüfterstufe 1";
        case 16:
            return "Halte Lüfterstufe 2";
        case 17:
            return "Halte Lüfterstufe 3";
        case 18:
            return "Halte Lüfterstufe 4";
        case 19:
            return "Halte Lüfterstufe 5";
        case 20:
            return "Halte Lüfterstufe 6";
        case 21:
            return "Halte Stoßlüftung";
        case 22:
            return "Halte Zeitautomatik";
        case 23:
            return "Halte CO2";
        case 24:
            return "Halte Feuchte";


    }
}

export function parseDOfunNumberToName(funNumber) {
    switch (funNumber) {
        default:
        case 0:
            return "Keine"
        case 1:
            return "Lüfterstufe 0 aktiv";
        case 2:
            return "Lüfterstufe 1 aktiv";
        case 3:
            return "Lüfterstufe 2 aktiv";
        case 4:
            return "Lüfterstufe 3 aktiv";
        case 5:
            return "Lüfterstufe 4 aktiv";
        case 6:
            return "Lüfterstufe 5 aktiv";
        case 7:
            return "Lüfterstufe 6 aktiv";
        case 8:
            return "Stoßlüftung aktiv";
        case 9:
            return "Schlummer aktiv";
        case 10:
            return "Alle Bereiche Lüfterstufe 0";
        case 11:
            return "Zeitautomatik aktiv";
        case 12:
            return "CO2 aktiv";
        case 13:
            return "Feuchte aktiv";
        case 14:
            return "Filter abgelaufen";
        case 15:
            return "Allgemeine Meldung";
        case 16:
            return "Allgemeiner Fehler";
    }
}

// returns numeric value of KD Firmware Code with A:1, B:2 and so on
export function getControlFirmwareVersionNumeric(articlecode) {

    let helpString = articlecode.toUpperCase()
    log.debug(helpString)
    let returnString = helpString.substr(-1,1)
   log.debug( returnString.charCodeAt(0)- "@".charCodeAt(0))
    return (returnString.charCodeAt(0) - "@".charCodeAt(0) )
}

// takes FW String in format "X.Y.Z" and returns numeric in format X*10^6+Y*10^3+Z
export function getGatewayFirmwareVersionNumeric(fwVersionString){
    if(!fwVersionString){
        return 0
    }
    let firstSeparatorPos = fwVersionString.indexOf('.',0)
    let secondSeparatorPos = fwVersionString.indexOf('.',firstSeparatorPos+1)
    let major = fwVersionString.substr(0,firstSeparatorPos)
    let minor = fwVersionString.substr(firstSeparatorPos+1,secondSeparatorPos-firstSeparatorPos-1)
    let fix = fwVersionString.substr(secondSeparatorPos+1,fwVersionString.length-secondSeparatorPos-1)
    log.debug(major, minor, fix )
    log.debug(parseInt(major,10)*1000000 + parseInt(minor,10)* 1000 + parseInt(fix,10))
    return(parseInt(major,10)*1000000 + parseInt(minor,10)* 1000 + parseInt(fix,10))
}


export function isActualGwFirmwareVersionNewerThanOrEqualTargetVersion(actualVersion, targetVersion){
    if(actualVersion >= targetVersion){
        return true
    }
    return false
}




export function isActualControlFirmwareVersionNewerThanOrEqualTargetVersion(actualVersion, targetVersion){
    if(actualVersion >= targetVersion){
        return true
    }
    return false
}

export function getBoolFromBoolString(bString){
    log.debug(bString)
    if(!bString){
        return false
    }
    if(bString.toLowerCase() === "true"){
        return true
    }
    return false 
}

export function getEnglishRoomNameByGerman(germanName) {
    // console.log(germanName)
    for (let index = 0; index < rooms.length; index++) {
        if(rooms[index].de === germanName){
            // console.log("RETURN!!!!: ", rooms[index].en)
            return rooms[index].en
        }
        
    }
    return germanName
   
}